/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import Image from 'next/image';

import Container from 'components/Container';
import { useTranslations } from 'next-intl';
import { useMediaQuery } from '@mui/material';

const mock = [
  {
    title: 'Cost-Effective',
    subtitle: 'Reduce your global expansion',
    icon: (
      <Image
        height={48}
        width={48}
        src="/images/others/GlobalExpansion-icon4.png"
        alt="icon"
      />
    ),
  },
  {
    title: 'Compliant',
    subtitle: 'Navigate complex international employment regulations',
    icon: (
      <Image
        height={48}
        width={48}
        src="/images/others/GlobalExpansion-icon5.png"
        alt="icon"
      />
    ),
  },
  {
    title: 'Fast',
    subtitle: 'Transform your global hiring timeline',
    icon: (
      <Image
        height={48}
        width={48}
        src="/images/others/GlobalExpansion-icon6.png"
        alt="icon"
      />
    ),
  },
];

const SimpleCentered = (): JSX.Element => {
  const theme = useTheme();
  const t = useTranslations('GlobalExpansion');
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Container>
      <Box>
        {/* <Box marginBottom={4}>
          <Box marginBottom={2}>
            <Typography
              variant="h4"
              color="text.primary"
              align={'center'}
              gutterBottom
              sx={{
                fontWeight: 700,
              }}
            >
              {t('Your One-stop Global Payroll Platform for All Your Teams')}
            </Typography>
            <Typography
              variant="h6"
              component="p"
              color="text.secondary"
              sx={{ fontWeight: 400 }}
              align={'center'}
            >
              {t('Managing international payroll can be challenging')}
            </Typography>
          </Box>
        </Box> */}
        <Grid container spacing={2}>
          {mock.map((item, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Box width={1} height={1}>
                <Box
                  display={'flex'}
                  flexDirection={'column'}
                  alignItems={'center'}
                >
                  <Box
                    component={Avatar}
                    width={60}
                    height={60}
                    marginBottom={2}
                    bgcolor={alpha(theme.palette.primary.main, 0.1)}
                    color={theme.palette.primary.main}
                  >
                    {item.icon}
                  </Box>
                  <Typography
                    variant={'h6'}
                    gutterBottom
                    sx={{ fontWeight: 500 }}
                    align={'center'}
                  >
                    {t(item.title)}
                  </Typography>
                  <Typography align={'center'} color="text.secondary">
                    {t(item.subtitle)}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
        {/* <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretched', sm: 'flex-start' }}
          justifyContent={'center'}
          marginTop={4}
        >
          <Button
            component={'a'}
            variant="contained"
            color="primary"
            size="large"
            fullWidth={isMd ? false : true}
            href={'/book-demo'}
          >
            {t('Pay my team')}
          </Button>
        </Box> */}
      </Box>
    </Container>
  );
};

export default SimpleCentered;
